import { T1_voices } from "./T1";
import { T2_voices } from "./T2";
import { T3_voices } from "./T3";
import { T4_voices } from "./T4";
import { T5_voices } from "./T5";
import { T6_voices } from "./T6";
import { T7_voices } from "./T7";
import { T8_voices } from "./T8";
import { T9_voices } from "./T9";

export const voicesGlobal = {
	T1: T1_voices,
	T2: T2_voices,
	T3: T3_voices,
	T4: T4_voices,
	T5: T5_voices,
	T6: T6_voices,
	T7: T7_voices,
	T8: T8_voices,
	T9: T9_voices,
}